import config from "../config/config.json";
import { headers } from "../APIHelpers/Headers";
import {
  handleResponse,
  headersWithAuth,
  headersWithAuthWithoutBody,
} from "../APIHelpers/Responses";

export const studyOnboardingService = {
  currentTime,

  //Projects
  createProjectID,
  getProjects,
  searchProjectData,
  getAllProjects,
  getAllProjectsofClients,
  updateProjectIDStatus,
  getProjectIdByStudyId,
  updateProjectID,

  //Studies
  createStudyID,
  updateStudyID,
  configurationStudyID,
  getStudies,
  getAllStudies,
  getSingleStudies,
  getStudiesUserDashboard,
  getProjectsUserDashboard,
  getProjectsClientDashboard,
  getStudiesClientDashboard,
  updateSudyIDStatus,
  etmfStudyDatabaseLockAndUnlock,
  getETMFStudyDatabaseLogs,
  etmfStudyDatabaseStatus,
  getTotalAssignedStudies,
  getTotalAssignedApps,

  //Control
  addAgeGroup,
  getAgeGroupList,
  updateAgeGroupData,
  addGender,
  getGenderList,
  updateGenderData,
  addUnits,
  getUnitsList,
  updateUnitsData,
  verifyStudyData,
  getVerifiedStudyData,
  getStudyModuleData,

  //Study login Bookmarks
  addStudyLoginBookmarks,
  getStudyLoginBookmarks,
  deleteStudyLoginBookmarks,

  sendStudyDatabaseStatusRequest,
  getStudyDatabaseStatusRequest,
  approvalStudyDatabaseStatusRequest,
  getStudyProjectDetails,

  // protocol metadata
  addProtocolMetadata,
  updateProtocolMetadataData,
  deleteProtocolMetadataData,
  getProtocolMetadataData,

  getGlobalAIAuditTrials,
  
  getStudyAuditTrials,
  getSiteAuditTrials,
  getAllStudyAuditTrials,

  getStudyEIWRSAuditTrials,
  getStudyAllEIWRSAuditTrialList,
  getAllStudyCTMSAuditTrials,
  
  getStudyETMFAuditTrials,
  getStudyAllETMFAuditTrialList,
  
  getStudyEPROAuditTrials,
  getStudyAllEPROAuditTrialList,

  getStudyICFAuditTrials,
  getStudyAllICFAuditTrialList,
  
  addStudyLoginHistory,
  getStudyLoginHistory,

  addStudyAppsLoginHistory, 
  getStudyAppsLoginHistory,
};

// Get Study All IWRS Audit Trial
async function getStudyAllEIWRSAuditTrialList(studyId, type, category, mode, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyAllEIWRSAuditTrialList/${studyId}/${type}/${category}/${mode}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyAllEIWRSAuditTrialList/${studyId}/${type}/${category}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Study All IWRS Audit Trial
async function getAllStudyCTMSAuditTrials(studyId, type, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getAllStudyCTMSAuditTrials/${studyId}/${type}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getAllStudyCTMSAuditTrials/${studyId}/${type}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Study All EDC Audit Trial
async function getAllStudyAuditTrials(studyId, type, category, mode, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getAllStudyAuditTrials/${studyId}/${type}/${category}/${mode}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getAllStudyAuditTrials/${studyId}/${type}/${category}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Study All ETMF Audit Trial
async function getStudyAllETMFAuditTrialList(studyId, type, category, mode, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyAllETMFAuditTrialList/${studyId}/${type}/${category}/${mode}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyAllETMFAuditTrialList/${studyId}/${type}/${category}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Study IWRS Audit Trial
async function getStudyEIWRSAuditTrials(type, studyId, uniqueId, mode, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyEIWRSAuditTrials/${type}/${studyId}/${uniqueId}/${mode}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyEIWRSAuditTrials/${type}/${studyId}/${uniqueId}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Study ETMF Audit Trial
async function getStudyETMFAuditTrials(type, studyId, uniqueId, mode, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyETMFAuditTrials/${type}/${studyId}/${uniqueId}/${mode}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyETMFAuditTrials/${type}/${studyId}/${uniqueId}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add Protocol
async function addProtocolMetadata(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addProtocolMetadata`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Update Protocol
async function updateProtocolMetadataData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateProtocolMetadataData`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Update Project ID
async function updateProjectID(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateProjectID`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Delete Protocol
async function deleteProtocolMetadataData(id) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteProtocolMetadataData/${id}`,
    headersWithAuthWithoutBody("DELETE", headers)
  );
  const data = await response.json();
  return data;
}

// Get Protocols
async function getProtocolMetadataData(studyId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getProtocolMetadataData/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function currentTime() {
  let today = new Date();
  let dd = String(today.getDate()).padStart(2, "0");
  let mm = String(today.getMonth() + 1).padStart(2, "0");
  let yyyy = today.getFullYear();
  let currentDate = yyyy + "-" + mm + "-" + dd;
  return currentDate;
}

async function getVerifiedStudyData(studyId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getVerifiedStudyData/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getStudyModuleData(studyId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyModuleData/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getProjectIdByStudyId(id) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getProjectIdByStudyId/${id}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getProjects(id) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getProjects/${id}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getAllProjects(status) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAllProjects/${status}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function searchProjectData(search) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}searchProjectData/${search}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}


async function getAllProjectsofClients(id) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAllProjectsofClients/${id}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getAllStudies(status) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAllStudies/${status}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getStudies(id) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudies/${id}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getTotalAssignedStudies() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getTotalAssignedStudies`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getTotalAssignedApps(studyId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getTotalAssignedApps/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getSingleStudies(id) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getSingleStudies/${id}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getStudiesUserDashboard() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudiesUserDashboard`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getProjectsUserDashboard() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getProjectsUserDashboard`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getProjectsClientDashboard() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getProjectsClientDashboard`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getStudiesClientDashboard() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudiesClientDashboard`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getETMFStudyDatabaseLogs(studyId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getETMFStudyDatabaseLogs/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function etmfStudyDatabaseStatus(studyId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}etmfStudyDatabaseStatus/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function updateProjectIDStatus(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateProjectIDStatus`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function updateSudyIDStatus(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateSudyIDStatus`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function etmfStudyDatabaseLockAndUnlock(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}etmfStudyDatabaseLockAndUnlock`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function createProjectID(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}createProjectID`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function verifyStudyData(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}verifyStudyData`,
    headersWithAuth("POST", datas, headers)
  );
 const data = await response.json();
  handleResponse(data);
  return data;
}

async function createStudyID(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}createStudyID`,
    headersWithAuth("POST", datas, headers)
  );
 const data = await response.json();
  handleResponse(data);
  return data;
  return data;
}

async function updateStudyID(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateStudyID`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function configurationStudyID(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}configurationStudyID`,
    headersWithAuth("PUT", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

// Controller API
async function addGender(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addGender`,
    headersWithAuth("POST", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function updateGenderData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateGenderData`,
    headersWithAuth("PUT", userData, headers)
  );
 const data = await response.json();
  handleResponse(data);
  return data;
}

async function getGenderList(studyId, currentPage, limit) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getGenderList/${studyId}/${currentPage}/${limit}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function addAgeGroup(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addAgeGroup`,
    headersWithAuth("POST", datas, headers)
  );
 const data = await response.json();
  handleResponse(data);
  return data;
}

async function updateAgeGroupData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateAgeGroupData`,
    headersWithAuth("PUT", userData, headers)
  );
 const data = await response.json();
  handleResponse(data);
  return data;
}

async function getAgeGroupList(studyId, currentPage, limit) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getAgeGroupList/${studyId}/${currentPage}/${limit}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function addUnits(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addUnits`,
    headersWithAuth("POST", datas, headers)
  );
 const data = await response.json();
  handleResponse(data);
  return data;
}

async function updateUnitsData(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}updateUnitsData`,
    headersWithAuth("PUT", userData, headers)
  );
 const data = await response.json();
  handleResponse(data);
  return data;
}

async function getUnitsList(studyId, currentPage, limit) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getUnitsList/${studyId}/${currentPage}/${limit}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function addStudyLoginBookmarks(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addStudyLoginBookmarks`,
    headersWithAuth("POST", userData, headers)
  );
 const data = await response.json();
  handleResponse(data);
  return data;
}

async function deleteStudyLoginBookmarks(datas) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}deleteStudyLoginBookmarks`,
    headersWithAuth("DELETE", datas, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function getStudyLoginBookmarks() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyLoginBookmarks`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function sendStudyDatabaseStatusRequest(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}sendStudyDatabaseStatusRequest`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function approvalStudyDatabaseStatusRequest(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}approvalStudyDatabaseStatusRequest`,
    headersWithAuth("PUT", userData, headers)
  );
  const data = await response.json();
  handleResponse(data);
  return data;
}

async function getStudyDatabaseStatusRequest(studyId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyDatabaseStatusRequest/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

async function getStudyProjectDetails(studyId) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyProjectDetails/${studyId}`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Audit Trial
async function getStudyAuditTrials(type, studyId, uniqueId, mode, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyAuditTrials/${type}/${studyId}/${uniqueId}/${mode}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyAuditTrials/${type}/${studyId}/${uniqueId}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Site Audit Trial
async function getSiteAuditTrials(studyId, siteId, mode, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSiteAuditTrials/${studyId}/${siteId}/${mode}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getSiteAuditTrials/${studyId}/${siteId}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Global Audit Trial
async function getGlobalAIAuditTrials(type, uniqueId, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getGlobalAIAuditTrials/${type}/${uniqueId}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getGlobalAIAuditTrials/${type}/${uniqueId}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Study EPRO Audit Trial
async function getStudyEPROAuditTrials(type, studyId, uniqueId, mode, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyEPROAuditTrials/${type}/${studyId}/${uniqueId}/${mode}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyEPROAuditTrials/${type}/${studyId}/${uniqueId}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Study All EPRO Audit Trial
async function getStudyAllEPROAuditTrialList(studyId, type, category, mode, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyAllEPROAuditTrialList/${studyId}/${type}/${category}/${mode}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyAllEPROAuditTrialList/${studyId}/${type}/${category}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Study ICF Audit Trial
async function getStudyICFAuditTrials(type, studyId, uniqueId, mode, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyICFAuditTrials/${type}/${studyId}/${uniqueId}/${mode}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyICFAuditTrials/${type}/${studyId}/${uniqueId}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Get Study All ICF Audit Trial
async function getStudyAllICFAuditTrialList(studyId, type, category, mode, page, length) {
  let response
  if (page && length) {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyAllICFAuditTrialList/${studyId}/${type}/${category}/${mode}?page=${page}&length=${length}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  } else {
    response = await fetch(
      `${config.API_URL_USER_ONBOARDING}getStudyAllICFAuditTrialList/${studyId}/${type}/${category}/${mode}`,
      headersWithAuthWithoutBody("GET", headers)
    );
  }
  const data = await response.json();
  return data;
}

// Add Study Login History
async function addStudyLoginHistory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addStudyLoginHistory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Login History
async function getStudyLoginHistory() {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyLoginHistory`,
    headersWithAuthWithoutBody("GET", headers)
  );
  const data = await response.json();
  return data;
}

// Add Study Apps Login History
async function addStudyAppsLoginHistory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}addStudyAppsLoginHistory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}

// Get Study Login History
async function getStudyAppsLoginHistory(userData) {
  const response = await fetch(
    `${config.API_URL_USER_ONBOARDING}getStudyAppsLoginHistory`,
    headersWithAuth("POST", userData, headers)
  );
  const data = await response.json();
  return data;
}